import axios from "axios";
import { config } from "./config";

export class Api {
  static API_BASE_URL =
    process.env.REACT_APP_ENV === "production" ? config.API_BASE_URL_PROD : config.API_BASE_URL_TEST;

  static BASE_URL = Api.API_BASE_URL;
  static ENDPOINTS = config.API_ENDPOINTS;

  static async getRequest(options) {
    const finalOptions = {
      json: true,
      ...options,
    };
    const result = await axios(finalOptions);
    return result.data;
  }

  static async GetReport(companyCode) {
    const options = {
      method: "POST",
      url: Api.BASE_URL + Api.ENDPOINTS.GetReport(companyCode),
    };
    const result = await Api.getRequest(options);
    return result;
  }
}
